import { render, staticRenderFns } from "./IrisTextfieldTelephone.vue?vue&type=template&id=50010f2d&"
import script from "./IrisTextfieldTelephone.vue?vue&type=script&lang=ts&"
export * from "./IrisTextfieldTelephone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports